import { SerialDescriptorForNullable2slcv65za9oog as SerialDescriptorForNullable } from '../internal/NullableSerializer.mjs';
import {
  equals2au1ep9vhcato as equals,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  toString1pkumu07cwy4m as toString,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { SerialDescriptor2pelqekb5ic3a as SerialDescriptor } from './SerialDescriptor.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function getContextualDescriptor(_this__u8e3s4, descriptor) {
  var tmp0_safe_receiver = get_capturedKClass(descriptor);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    var tmp0_safe_receiver_0 = _this__u8e3s4.getContextual$default_5chm2b_k$(tmp0_safe_receiver);
    tmp = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.get_descriptor_wjt6a0_k$();
  }
  return tmp;
}
function get_capturedKClass(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof ContextDescriptor()) {
    tmp = _this__u8e3s4.kClass_1;
  } else {
    if (_this__u8e3s4 instanceof SerialDescriptorForNullable()) {
      tmp = get_capturedKClass(_this__u8e3s4.original_1);
    } else {
      tmp = null;
    }
  }
  return tmp;
}
var ContextDescriptorClass;
function ContextDescriptor() {
  if (ContextDescriptorClass === VOID) {
    class $ {
      constructor(original, kClass) {
        this.original_1 = original;
        this.kClass_1 = kClass;
        this.serialName_1 = this.original_1.get_serialName_u2rqhk_k$() + '<' + this.kClass_1.get_simpleName_r6f8py_k$() + '>';
      }
      get_serialName_u2rqhk_k$() {
        return this.serialName_1;
      }
      equals(other) {
        var tmp0_elvis_lhs = other instanceof ContextDescriptor() ? other : null;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return false;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var another = tmp;
        return equals(this.original_1, another.original_1) && another.kClass_1.equals(this.kClass_1);
      }
      hashCode() {
        var result = this.kClass_1.hashCode();
        result = imul(31, result) + getStringHashCode(this.serialName_1) | 0;
        return result;
      }
      toString() {
        return 'ContextDescriptor(kClass: ' + toString(this.kClass_1) + ', original: ' + toString(this.original_1) + ')';
      }
      get_kind_wop7ml_k$() {
        return this.original_1.get_kind_wop7ml_k$();
      }
      get_isNullable_67sy7o_k$() {
        return this.original_1.get_isNullable_67sy7o_k$();
      }
      get_isInline_usk17w_k$() {
        return this.original_1.get_isInline_usk17w_k$();
      }
      get_elementsCount_288r0x_k$() {
        return this.original_1.get_elementsCount_288r0x_k$();
      }
      get_annotations_20dirp_k$() {
        return this.original_1.get_annotations_20dirp_k$();
      }
      getElementName_u4sqmf_k$(index) {
        return this.original_1.getElementName_u4sqmf_k$(index);
      }
      getElementIndex_utfbym_k$(name) {
        return this.original_1.getElementIndex_utfbym_k$(name);
      }
      getElementAnnotations_omrjs6_k$(index) {
        return this.original_1.getElementAnnotations_omrjs6_k$(index);
      }
      getElementDescriptor_ncda77_k$(index) {
        return this.original_1.getElementDescriptor_ncda77_k$(index);
      }
      isElementOptional_heqq56_k$(index) {
        return this.original_1.isElementOptional_heqq56_k$(index);
      }
    }
    initMetadataForClass($, 'ContextDescriptor', VOID, VOID, [SerialDescriptor()]);
    ContextDescriptorClass = $;
  }
  return ContextDescriptorClass;
}
function withContext(_this__u8e3s4, context) {
  return new (ContextDescriptor())(_this__u8e3s4, context);
}
//region block: exports
export {
  getContextualDescriptor as getContextualDescriptor2n1gf3b895yb8,
  withContext as withContext3ge61vpog00ae,
};
//endregion

//# sourceMappingURL=ContextAware.mjs.map
